export const error = state => state.error
export const isLoading = state => state.isLoading
export function retrieved (state) {
  if (state.retrieved) {
    if (state.retrieved.idStatus && typeof state.retrieved.idStatus === 'object') {
      state.retrieved.idStatus = state.retrieved.idStatus['@id']
    }
    if (state.retrieved.idSalesOpportunity && typeof state.retrieved.idSalesOpportunity === 'object') {
      state.retrieved.idSalesOpportunity = state.retrieved.idSalesOpportunity['@id']
    }
    if (state.retrieved.idUserData && typeof state.retrieved.idUserData === 'object') {
      state.retrieved.idUserData = state.retrieved.idUserData['@id']
    }
    if (state.retrieved.idSalesRepresentative && typeof state.retrieved.idSalesRepresentative === 'object') {
      state.retrieved.idSalesRepresentative = state.retrieved.idSalesRepresentative['@id']
    }
    state.retrieved.tags = state.retrieved.tags.map(entry => {
      if (entry.tag && entry.tag.tag) {
        return { '@id': entry['@id'], value: entry.tag['@id'], text: entry.tag.tag }
      } else {
        return { '@id': entry['@id'], value: entry.value, text: entry.text }
      }
    })
  }
  return state.retrieved
}
export const updated = state => state.updated
export const violations = state => state.violations
